import { CircularProgress } from '@mui/material';
import { ModalSpinnerWrapper, SpinnerWrapper } from './Loader.styles';

interface ILoaderProps {
  isLoading: boolean;
  isModal?: boolean;
}

export const Loader = ({ isLoading, isModal = false }: ILoaderProps) => {
  return (
    <>
      {isLoading &&
        (isModal ? (
          <ModalSpinnerWrapper>
            <CircularProgress />
          </ModalSpinnerWrapper>
        ) : (
          <SpinnerWrapper>
            <CircularProgress />
          </SpinnerWrapper>
        ))}
    </>
  );
};
